import { render, staticRenderFns } from "./StepDetails.vue?vue&type=template&id=a6cf0a84&lang=html&"
import script from "./StepDetails.vue?vue&type=script&lang=js&"
export * from "./StepDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports